import Node from './nodes/Node';
import SyntacticAnalyzer from './SyntacticAnalyzer';
import LexicalAnalyzer from './LexicalAnalyzer';
import * as Voca from 'voca';
import TextType from './nodes/TextType';
import AnalysisMode from './AnalysisMode';

export default class NodeToTextConverter {

	public static execute (node: Node, textType: TextType = TextType.PLAIN) {
		let plainText = node.toText(TextType.PLAIN);

		const redundantParenthesisIndeces = this.determineRedundantPerentheseIndeces(plainText);

		return this.removeRedundantParentheses(node.toText(textType), redundantParenthesisIndeces);
	}

	private static determineRedundantPerentheseIndeces (text: string) {
		const parenthesisCharacterIndeces: number[] = [];

		for (let i = 0; i < text.length; i++) {
			if (text[i] === '(') {
				let depth = 1;

				for (let j = i + 1; j < text.length; j++) {
					if (text[j] === '(') {
						depth++;
					} else if (text[j] === ')') {
						depth--;

						if (depth === 0) {
							const reducedText = text.slice(0, i) + text.slice(i + 1, j) + text.slice(j + 1);

							if (SyntacticAnalyzer.execute(LexicalAnalyzer.execute(reducedText, AnalysisMode.TEXT), AnalysisMode.TEXT).toText(TextType.PLAIN) === text) {
								parenthesisCharacterIndeces.push(i);
								parenthesisCharacterIndeces.push(j);
							}

							break;
						}
					}
				}
			}
		}

		let parenthesisIndex = 0;

		const parenthesisIndeces: number[] = [];

		for (let i = 0; i < text.length; i++) {
			const character = text[i];

			if (['(', ')'].includes(character)) {
				if (parenthesisCharacterIndeces.includes(i)) {
					parenthesisIndeces.push(parenthesisIndex);
				}

				parenthesisIndex++;

			}
		}

		return parenthesisIndeces;
	}

	private static removeRedundantParentheses (originalText: string, redundantParenthesisIndeces: number[]) {
		let text = '';

		let parenthesisIndex = 0;

		for (let i = 0; i < originalText.length; i++) {
			const character = originalText[i];

			if (['(', ')'].includes(character)) {
				parenthesisIndex++;

				if (redundantParenthesisIndeces.includes(parenthesisIndex - 1)) {
					continue;
				}
			}

			text += character;
		}

		text = Voca.replaceAll(text, '{(', '{');
		text = Voca.replaceAll(text, ')}', '}');

		text = Voca.replaceAll(text, '}(', '}');
		text = Voca.replaceAll(text, '\\(', '\\');
		text = Voca.replaceAll(text, ')\\', '\\');

		return text;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/NodeToTextConverter.ts